import React from 'react';
import { Box } from '@mui/material';
import { BrowserRouter as Router, Navigate, Routes, Route } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import AppShell from './components/AppShell';
import DeviceList from './components/DeviceList';
import DeviceDetail from './components/DeviceDetail';
import FileManager from './components/FileManager';
import FlashDevice from './components/FlashDevice';
import LayoutEditor from './components/LayoutEditor';
import SignalsEditor from './components/SignalsEditor';
import ShopfloorPage from './shopfloor/ShopfloorPage';
import FlowEditor from './flow/FlowEditor';
import DeviceConfigEditor from './devices/DeviceConfigEditor';
import DashboardPage from './components/Dashboard';
import AlertingPage from './alerting/AlertingPage';
import SettingsPage from './settings/SettingsPage';
import InstancesPage from './instances/InstancesPage';
import SetupLayout from './setup/SetupLayout';
import ControllerLayout from './controllers/ControllerLayout';
import ControllerWorkspace from './controllers/ControllerWorkspace';
import RedirectWithSearch, {
  RedirectDeviceDetail,
  RedirectLegacyFiles,
  RedirectLegacyHardware,
} from './nav/RedirectWithSearch';
import {
  ALERTS_PATH,
  CONTROLLERS_PATH,
  CONTROLLERS_USB_PATH,
  DASHBOARD_PATH,
  INSTANCES_PATH,
  SETTINGS_PATH,
  SETUP_DISPLAY_PATH,
  SETUP_FLOW_PATH,
  SETUP_PATH,
  SETUP_SIGNALS_PATH,
  SHOPFLOOR_PATH,
} from './nav/paths';
import { UsbSessionProvider } from './flash/UsbSessionContext';
import { ColorModeProvider } from './theme/ColorModeProvider';

function App() {
  return (
    <ColorModeProvider>
      <CssBaseline />
      <Router>
        <UsbSessionProvider>
          <AppShell>
            <Box sx={{ flex: 1, minHeight: 0, height: '100%', display: 'flex', flexDirection: 'column' }}>
            <Routes>
              <Route path="/" element={<Navigate to={DASHBOARD_PATH} replace />} />
              <Route path={DASHBOARD_PATH} element={<DashboardPage />} />
              <Route path={ALERTS_PATH} element={<AlertingPage />} />
              <Route path={SETTINGS_PATH} element={<SettingsPage />} />
              <Route path={INSTANCES_PATH} element={<InstancesPage />} />
              <Route path={SHOPFLOOR_PATH} element={<ShopfloorPage />} />

              <Route path={SETUP_PATH} element={<SetupLayout />}>
                <Route index element={<Navigate to="flow" replace />} />
                <Route path="flow" element={<FlowEditor />} />
                <Route path="display" element={<LayoutEditor />} />
                <Route path="signals" element={<SignalsEditor />} />
                <Route path="hardware" element={<RedirectLegacyHardware />} />
                <Route path="files" element={<RedirectLegacyFiles />} />
              </Route>

              <Route path={CONTROLLERS_PATH} element={<ControllerLayout />}>
                <Route index element={<DeviceList />} />
                <Route path="usb" element={<FlashDevice />} />
              </Route>
              <Route path={`${CONTROLLERS_PATH}/:deviceId`} element={<ControllerWorkspace />}>
                <Route index element={<DeviceDetail />} />
                <Route path="hardware" element={<DeviceConfigEditor />} />
                <Route path="files" element={<FileManager />} />
              </Route>

              <Route path="/files" element={<RedirectLegacyFiles />} />
              <Route path="/device-config" element={<RedirectLegacyHardware />} />
              <Route path="/flow" element={<RedirectWithSearch to={SETUP_FLOW_PATH} />} />
              <Route path="/layout" element={<RedirectWithSearch to={SETUP_DISPLAY_PATH} />} />
              <Route path="/signals" element={<RedirectWithSearch to={SETUP_SIGNALS_PATH} />} />
              <Route path="/flash" element={<RedirectWithSearch to={CONTROLLERS_USB_PATH} />} />
              <Route path="/console" element={<Navigate to={CONTROLLERS_PATH} replace />} />
              <Route path="/device/:deviceId" element={<RedirectDeviceDetail />} />
            </Routes>
            </Box>
          </AppShell>
        </UsbSessionProvider>
      </Router>
    </ColorModeProvider>
  );
}

export default App;
